// SALDP white-labelling. Added by Sullivan Digital, 2026-10-26. Licensed under the GNU AGPL v3; see LICENSE-AGPL.txt.
import type { State } from "metabase/redux/store";
import { getSetting } from "metabase/settings";
import type { ResolvedColorScheme } from "metabase/utils/color-scheme";

export const DEFAULT_BRAND_NAME = "Analytics";
export const MAX_BRAND_NAME_LENGTH = 60;
export const DEFAULT_LOGO_URL = "app/assets/img/saldp/brand-mark.svg";
export const DEFAULT_FAVICON_URL = "app/assets/img/saldp/favicon.svg";

export function getBrandName(state: State): string {
  return getSetting(state, "application-name") || DEFAULT_BRAND_NAME;
}

/** The logo for `colorScheme`; dark mode falls back to the light logo. */
export function getBrandLogoUrl(
  state: State,
  colorScheme: ResolvedColorScheme,
): string {
  const lightLogoUrl =
    getSetting(state, "application-logo-url") || DEFAULT_LOGO_URL;
  const darkLogoUrl = getSetting(state, "saldp-logo-dark-url");

  return colorScheme === "dark" && darkLogoUrl ? darkLogoUrl : lightLogoUrl;
}

export function getShowMetabaseLinks(state: State): boolean {
  return getSetting(state, "show-metabase-links");
}
